import { Suspense } from 'react';

// custom TRUCRED loader
import Loader from 'ui-component/Loader';

const Loadable = (Component) => (props) => (
    <Suspense fallback={<Loader />}>
        <Component {...props} />
    </Suspense>
);

export default Loadable;
